import React, { useRef, useState } from "react";
import { api, resolveImageUrl } from "@/lib/api";
import { UploadSimple, X } from "@phosphor-icons/react";
import { toast } from "sonner";

// URL input + drag/click upload zone with preview. Uploads to object storage.
export default function ImageUploadField({ value, onChange, label = "Imagem", hint, testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [drag, setDrag] = useState(false);

  async function upload(file) {
    if (!file || !file.type.startsWith("image/")) { toast.error("Escolhe um ficheiro de imagem"); return; }
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/admin/upload-banner", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.image_url);
      toast.success("Imagem carregada");
    } catch (e) { toast.error("Falha no upload da imagem"); }
    finally { setUploading(false); }
  }

  return (
    <div className="space-y-2" data-testid={testid}>
      <label className="text-xs font-mono-accent text-zinc-400 uppercase tracking-wider">{label}</label>
      <div className="flex items-center gap-2">
        <input
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://exemplo.com/imagem.jpg"
          className="flex-1 bg-[#1C1C22] border border-white/10 rounded-lg h-10 px-3 text-sm outline-none focus:border-[#E63946]/50"
          data-testid={`${testid}-url`}
        />
        {value && (
          <button type="button" onClick={() => onChange("")} className="w-10 h-10 rounded-lg border border-white/10 grid place-items-center text-zinc-400 hover:text-[#E63946]" data-testid={`${testid}-clear`}>
            <X size={16} weight="bold" />
          </button>
        )}
      </div>
      <div
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); upload(e.dataTransfer.files?.[0]); }}
        className={`cursor-pointer rounded-xl border-2 border-dashed p-4 flex items-center gap-3 transition-colors ${drag ? "border-[#E63946] bg-[#E63946]/10" : "border-white/10 hover:border-white/20 bg-[#151519]"}`}
        data-testid={`${testid}-dropzone`}
      >
        {value ? (
          <img src={resolveImageUrl(value)} alt="" className="w-14 h-14 rounded-lg object-cover flex-shrink-0 border border-white/10" onError={(e) => { e.target.style.display = "none"; }} />
        ) : (
          <div className="w-14 h-14 rounded-lg bg-white/5 grid place-items-center flex-shrink-0 text-zinc-500"><UploadSimple size={22} weight="bold" /></div>
        )}
        <div className="text-sm">
          <div className="font-display font-semibold text-zinc-200">{uploading ? "A carregar..." : "Arraste uma imagem aqui ou clique para selecionar"}</div>
          <div className="text-[11px] text-zinc-500">{hint || "PNG, JPG ou WEBP · do teu computador"}</div>
        </div>
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files?.[0])} disabled={uploading} data-testid={`${testid}-input`} />
      </div>
    </div>
  );
}
